import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ImageComponent } from '@shared/components/image';
import { Image } from '@shared/components/image/models';

@Component({
  selector: 'app-option-card',
  imports: [ImageComponent],
  templateUrl: './option-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionCardComponent {
  readonly image = input.required<Image>();
  readonly hasBackground = input(true);
  readonly isPriority = input(false);
  readonly imageCursorType = input<'pointer' | 'zoomIn'>();
  readonly imageClicked = output();
}
